import { supportCameFromInstanceCustomDomain } from '@openx/utils/session/cameFromInstanceCustomDomain';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';

import { App } from './App';

const container = document.getElementById('root');
const root = createRoot(container as HTMLElement);

supportCameFromInstanceCustomDomain();

root.render(
  <StrictMode>
    <BrowserRouter useTransitions={false}>
      <App />
    </BrowserRouter>
  </StrictMode>
);
